import React from 'react';
import BuildIcon from '@mui/icons-material/Build';
import { Grid, FormControlLabel, Checkbox } from '@mui/material';

const TabFour = ({
  setOthers,
  others,
  setOthersEdit,
  othersEdit,
  onClickAll,
  isEdit
}) => {
  return (
    <Grid container>
      <Grid item xs={12} sx={{ mt: 1 }}>
        <FormControlLabel
          id="others-form-all"
          control={
            <Checkbox
              id="others-all"
              checked={others.every((dash) => dash.value)}
              onClick={(e) => onClickAll(others, 'common', setOthers, e)}
              disabled={isEdit}
            />
          }
          label="All"
        />
        <Checkbox
          checked={othersEdit.every((dash) => dash.value)}
          onClick={(e) => onClickAll(othersEdit, 'common', setOthersEdit, e)}
          disabled={isEdit}
          icon={
            <BuildIcon
              sx={{
                fontSize: '0.8rem',
                color: `gray`
              }}
            />
          }
          checkedIcon={
            <BuildIcon
              sx={{
                fontSize: '0.8rem',
                color: `blue`
              }}
            />
          }
        />
      </Grid>
      <Grid item xs={4}>
        {others.map(
          (data, index) =>
            data.name === 'View Segments' && (
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={isEdit}
                    checked={others[index]?.value}
                    onChange={(e) => {
                      let items = [...others];
                      let item = { ...items[index] };
                      item = {
                        id: data.id,
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setOthers(items);
                    }}
                  />
                }
                label={data.name}
              />
            )
        )}
        {othersEdit.map(
          (data, index) =>
            data.name === 'Edit Segments' && (
              <BuildIcon
                onClick={() => {
                  let items = [...othersEdit];
                  let item = { ...items[index] };
                  item = {
                    id: data.id,
                    name: data.name,
                    tab: data.tab,
                    value: !data.value
                  };
                  items[index] = item;
                  if (!isEdit) setOthersEdit(items);
                }}
                sx={{
                  fontSize: '0.8rem',
                  color: `${data.value === false ? 'gray' : 'blue'}`
                }}
              />
            )
        )}
      </Grid>
      <Grid item xs={4}>
        {others.map(
          (data, index) =>
            data.name === 'View Customer' && (
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={isEdit}
                    checked={others[index]?.value}
                    onChange={(e) => {
                      let items = [...others];
                      let item = { ...items[index] };
                      item = {
                        id: data.id,
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setOthers(items);
                    }}
                  />
                }
                label={data.name}
              />
            )
        )}
        {othersEdit.map(
          (data, index) =>
            data.name === 'Edit Customer' && (
              <BuildIcon
                onClick={() => {
                  let items = [...othersEdit];
                  let item = { ...items[index] };
                  item = {
                    id: data.id,
                    name: data.name,
                    tab: data.tab,
                    value: !data.value
                  };
                  items[index] = item;
                  if (!isEdit) setOthersEdit(items);
                }}
                sx={{
                  fontSize: '0.8rem',
                  color: `${data.value === false ? 'gray' : 'blue'}`
                }}
              />
            )
        )}
      </Grid>
      <Grid item xs={4}>
        {others.map(
          (data, index) =>
            data.name === 'View Stakeholder' && (
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={isEdit}
                    checked={others[index]?.value}
                    onChange={(e) => {
                      let items = [...others];
                      let item = { ...items[index] };
                      item = {
                        id: data.id,
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setOthers(items);
                    }}
                  />
                }
                label={data.name}
              />
            )
        )}
        {othersEdit.map(
          (data, index) =>
            data.name === 'Edit Stakeholder' && (
              <BuildIcon
                onClick={() => {
                  let items = [...othersEdit];
                  let item = { ...items[index] };
                  item = {
                    id: data.id,
                    name: data.name,
                    tab: data.tab,
                    value: !data.value
                  };
                  items[index] = item;
                  if (!isEdit) setOthersEdit(items);
                }}
                sx={{
                  fontSize: '0.8rem',
                  color: `${data.value === false ? 'gray' : 'blue'}`
                }}
              />
            )
        )}
      </Grid>
      <Grid item xs={4}>
        {others.map(
          (data, index) =>
            data.name === 'View Project Health Summary' && (
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={isEdit}
                    checked={others[index]?.value}
                    onChange={(e) => {
                      let items = [...others];
                      let item = { ...items[index] };
                      item = {
                        id: data.id,
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setOthers(items);
                    }}
                  />
                }
                label={data.name}
              />
            )
        )}
      </Grid>
      <Grid item xs={4}>
        {others.map(
          (data, index) =>
            data.name === 'View Skills' && (
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={isEdit}
                    checked={others[index]?.value}
                    onChange={(e) => {
                      let items = [...others];
                      let item = { ...items[index] };
                      item = {
                        id: data.id,
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setOthers(items);
                    }}
                  />
                }
                label={'View Holiday Calendar'}
              />
            )
        )}
        {othersEdit.map(
          (data, index) =>
            data.name === 'Edit Skills' && (
              <BuildIcon
                onClick={() => {
                  let items = [...othersEdit];
                  let item = { ...items[index] };
                  item = {
                    id: data.id,
                    name: data.name,
                    tab: data.tab,
                    value: !data.value
                  };
                  items[index] = item;
                  if (!isEdit) setOthersEdit(items);
                }}
                sx={{
                  fontSize: '0.8rem',
                  color: `${data.value === false ? 'gray' : 'blue'}`
                }}
              />
            )
        )}
      </Grid>
      <Grid item xs={4}>
        {others.map(
          (data, index) =>
            data.name === 'View Resources' && (
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={isEdit}
                    checked={others[index]?.value}
                    onChange={(e) => {
                      let items = [...others];
                      let item = { ...items[index] };
                      item = {
                        id: data.id,
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setOthers(items);
                    }}
                  />
                }
                label={data.name}
              />
            )
        )}
        {othersEdit.map(
          (data, index) =>
            data.name === 'Edit Resources' && (
              <BuildIcon
                onClick={() => {
                  let items = [...othersEdit];
                  let item = { ...items[index] };
                  item = {
                    id: data.id,
                    name: data.name,
                    tab: data.tab,
                    value: !data.value
                  };
                  items[index] = item;
                  if (!isEdit) setOthersEdit(items);
                }}
                sx={{
                  fontSize: '0.8rem',
                  color: `${data.value === false ? 'gray' : 'blue'}`
                }}
              />
            )
        )}
      </Grid>
      <Grid item xs={4}>
        {others.map(
          (data, index) =>
            data.name === 'View Carry Forwarded Leaves' && (
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={isEdit}
                    checked={others[index]?.value}
                    onChange={(e) => {
                      let items = [...others];
                      let item = { ...items[index] };
                      item = {
                        id: data.id,
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setOthers(items);
                    }}
                  />
                }
                label={data.name}
              />
            )
        )}
        {othersEdit.map(
          (data, index) =>
            data.name === 'Edit Carry Forwarded Leaves' && (
              <BuildIcon
                onClick={() => {
                  let items = [...othersEdit];
                  let item = { ...items[index] };
                  item = {
                    id: data.id,
                    name: data.name,
                    tab: data.tab,
                    value: !data.value
                  };
                  items[index] = item;
                  if (!isEdit) setOthersEdit(items);
                }}
                sx={{
                  fontSize: '0.8rem',
                  color: `${data.value === false ? 'gray' : 'blue'}`
                }}
              />
            )
        )}
      </Grid>
      <Grid item xs={4}>
        {others.map(
          (data, index) =>
            data.name === 'View Configurations' && (
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={isEdit}
                    checked={others[index]?.value}
                    onChange={(e) => {
                      let items = [...others];
                      let item = { ...items[index] };
                      item = {
                        id: data.id,
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setOthers(items);
                    }}
                  />
                }
                label={data.name}
              />
            )
        )}
        {othersEdit.map(
          (data, index) =>
            data.name === 'Edit Configurations' && (
              <BuildIcon
                onClick={() => {
                  let items = [...othersEdit];
                  let item = { ...items[index] };
                  item = {
                    id: data.id,
                    name: data.name,
                    tab: data.tab,
                    value: !data.value
                  };
                  items[index] = item;
                  if (!isEdit) setOthersEdit(items);
                }}
                sx={{
                  fontSize: '0.8rem',
                  color: `${data.value === false ? 'gray' : 'blue'}`
                }}
              />
            )
        )}
      </Grid>
      <Grid item xs={4}>
        {others.map(
          (data, index) =>
            data.name === 'View Define Leaves' && (
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={isEdit}
                    checked={others[index]?.value}
                    onChange={(e) => {
                      let items = [...others];
                      let item = { ...items[index] };
                      item = {
                        id: data.id,
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setOthers(items);
                    }}
                  />
                }
                label={data.name}
              />
            )
        )}
        {othersEdit.map(
          (data, index) =>
            data.name === 'Edit Define Leaves' && (
              <BuildIcon
                onClick={() => {
                  let items = [...othersEdit];
                  let item = { ...items[index] };
                  item = {
                    id: data.id,
                    name: data.name,
                    tab: data.tab,
                    value: !data.value
                  };
                  items[index] = item;
                  if (!isEdit) setOthersEdit(items);
                }}
                sx={{
                  fontSize: '0.8rem',
                  color: `${data.value === false ? 'gray' : 'blue'}`
                }}
              />
            )
        )}
      </Grid>
      <Grid item xs={4}>
        {others.map(
          (data, index) =>
            data.name === 'View Year Plan' && (
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={isEdit}
                    checked={others[index]?.value}
                    onChange={(e) => {
                      let items = [...others];
                      let item = { ...items[index] };
                      item = {
                        id: data.id,
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setOthers(items);
                    }}
                  />
                }
                label={data.name}
              />
            )
        )}
        {othersEdit.map(
          (data, index) =>
            data.name === 'Edit Year Plan' && (
              <BuildIcon
                onClick={() => {
                  let items = [...othersEdit];
                  let item = { ...items[index] };
                  item = {
                    id: data.id,
                    name: data.name,
                    tab: data.tab,
                    value: !data.value
                  };
                  items[index] = item;
                  if (!isEdit) setOthersEdit(items);
                }}
                sx={{
                  fontSize: '0.8rem',
                  color: `${data.value === false ? 'gray' : 'blue'}`
                }}
              />
            )
        )}
      </Grid>
    </Grid>
  );
};

export default TabFour;
